import React from 'react';
import { PrimaryButton, useOverflowStatus } from '@atlaskit/atlassian-navigation';
import { ButtonItem } from '@atlaskit/menu';
import { NavLink } from 'react-router-dom';
import './navigation-button.scss';

type NavigationButtonProps = {
  href: string;
  children: JSX.Element | string;
  testId: string;
  exact: boolean;
};

export const NavigationButton = (props: NavigationButtonProps) => {
  const { href, children, testId, exact } = props;
  const overFlowStatus = useOverflowStatus();

  return overFlowStatus.isVisible ? (
    <NavLink to={href} exact={exact} className="navigation-button-link" activeClassName="active">
      <PrimaryButton testId={testId}>{children}</PrimaryButton>
    </NavLink>
  ) : (
    <NavLink to={href} exact={exact} className="collapsed-navigation-button-link" activeClassName="active">
      <ButtonItem testId={testId} isSelected>
        {children}
      </ButtonItem>
    </NavLink>
  );
};
